__webpack_require__.p = "/wp-content/themes/cornell-engineering/dist/";